module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_01-9922767fd0fe8a85f2edd776e3a1a21f.jpg";